import { Locale, LocaleType } from "./Locale";
import { PipaConsentValue } from "./PipaConsent";

export class WedgeOrder {
    constructor(
        public objectId = "", 
        public appVersion = "", 
        public appVersions = "",
        public appointmentID = 0, 
        public accountNumber = "", 
        public clientEmail = "", 
        public clientFirstName = "", 
        public clientLastName = "",
        public comments = "", 
        public consentDataCollection?: PipaConsentValue,
	    public consentDataThirdparty?: PipaConsentValue,
	    public consentDataInternational?: PipaConsentValue,
        public country = "", 
        public locale: LocaleType = Locale.english, 
        public utcOffset = "", 
        public dateFitted = "", 
        public dateUploaded = "", 
        public deviceID = "", 
        public emailRecipients = [] as Array<string>,
        public eventDate = "", 
        public eventID = 0, 
        public eventInstanceID = 0, 
        public eventType = "", 
        public regionID = 0, 
        public fitterID = 0, 
        public fitterEmail = "", 
        public fitterFirstName = "",
        public fitterLastName = "", 
        public fitterLocale: LocaleType = Locale.english, 
        public locationID = "", 
        public newsletterOptIn = "", 
        public status = "", 
        public timestamp = "", 
        public venueEmail = "",
        public venueName = "", 
        public venueType = "", 
        public venueTypeID = 0, 
        public headerJson = "", 
        public clubs = [] as Array<ClubDetail>, 
        public enhancedFittingData = "",
        public clientPhoneNumber = "",
        public smsOptIn = false
        ) { }
}


export class ClubDetail {
    public constructor(public lineNumber: number, public club: string, clubItemNumber: string, public quantity: number, public quantityInSet: number, public hand: string, public model: string, public ordered: boolean, public set: string, public lineJson: string) { }
}

//solely for formatting Your Game selections on an email
export class YourGame {
    constructor(public courseConditions = "", public bunkerConditions = "", public bunkerConfidence = "") { }
}

